import React, { useState } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import api from "../../utils/api";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

const CreateKeywordCategoryModal = ({ open, onClose, fetchCategories }) => {
  const [categoryName, setCategoryName] = useState("");

  const createCategory = async () => {
    if (!categoryName.trim()) {
      toast.error("Category name cannot be empty");
      return;
    }

    try {
      const res = await api.post(
        `${process.env.REACT_APP_BASE_URL}keyword-category/create`,
        { categoryName },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success(res.data.message || "Category created!");
      setCategoryName("");
      fetchCategories();
      onClose();
    } catch (err) {
      toast.error("Failed to create category");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" textAlign="center" color={"black"}>
          Create Keyword Category
        </Typography>

        <TextField
          label="Category Name"
          fullWidth
          sx={{ mt: 2 }}
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
        />

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, backgroundColor: "#1B3C73" }}
          onClick={createCategory}
        >
          Create
        </Button>
      </Box>
    </Modal>
  );
};

export default CreateKeywordCategoryModal;
